export default "__VITE_ASSET__DTx$Ewyl__"